var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTxnQuotationV1 = function SvgTxnQuotationV1(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Quotation"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.11,1.44a1.26,1.26,0,0,1,.26,1V35.61c-.27.12-.45-.07-.65-.18-1.27-.77-2.52-1.59-3.79-2.36-.25-.15-.48-.31-.4-.66a7,7,0,0,0,.1-1.29V7.51c0-.15,0-.3,0-.45,0-.69-.17-.83-.84-.87-.28,0-.56,0-.84,0H21a3.76,3.76,0,0,1-1.16-.07.75.75,0,0,1-.2-.15,3.48,3.48,0,0,1-.13-1.47q0-1.1,0-2.19A.83.83,0,0,1,20,1.44Z",
    style: {
      fill: "#84eeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,1.44a1.2,1.2,0,0,0-.27.82c0,1.23,0,2.47,0,3.71a.75.75,0,0,1-.59.18H15.78A.75.75,0,0,1,15.19,6c0-1.24,0-2.48,0-3.71a1.11,1.11,0,0,1,.27-.82Z",
    style: {
      fill: "#3ae4df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7,62.44c-8.71,0-25,0-33.76,0-1.63,0-3.26.1-4.9.1-.23,0-.48.08-.67-.12a1,1,0,0,1,.85-.21q1.26,0,2.52,0c.42,0,.6-.16.57-.58,0-.17,0-.35,0-.52q0-24.58,0-49.18c0-.46-.15-1,.33-1.31v0a1.06,1.06,0,0,1,.73-.19c1.23,0,2.46,0,3.68,0a10.1,10.1,0,0,1,1.1,0H42.81c1.49,0,1.58.09,1.58,1.57V29.4a5.43,5.43,0,0,1,0,.9.94.94,0,0,1-.48.65c-3.16,1.95-6.31,3.93-9.49,5.87a2.25,2.25,0,0,1-.71.26c-2.66.07-5.33,0-8,0a5.91,5.91,0,0,0-.84,0,.78.78,0,0,0-.74.83c0,.5.38.65.8.66,1.55,0,3.1,0,4.64,0,.39,0,8.39,0,8.75.16-.26.93,0,1.93-.38,2.84-.34.19-8.32.12-8.69.12H14.94a2.67,2.67,0,0,0-1.09.11c-.33.15-.6.37-.55.78a.7.7,0,0,0,.67.6,4.52,4.52,0,0,0,.9,0H29.22c.39,0,8.4,0,8.75.19a4.89,4.89,0,0,1,0,2.76c-.33.26-8.35.17-8.73.17-4.74,0-9.49,0-14.23,0a3,3,0,0,0-1.15.13c-.35.13-.62.35-.57.76A.7.7,0,0,0,14,48a7.85,7.85,0,0,0,.84,0H29.22c.38,0,8.4,0,8.75.19a4.89,4.89,0,0,1,0,2.76c-.34.26-8.36.17-8.74.17H15.09a3.41,3.41,0,0,0-1.15.1c-.37.13-.68.34-.64.79s.36.6.77.63c.26,0,.52,0,.78,0H29.33a4.42,4.42,0,0,1,1,0c.31.06,8,.33,8.07.59A12,12,0,0,0,43,59.89c.85.66,1.67,1.36,2.46,2.09C45.57,62.1,45.78,62.2,45.7,62.44Z",
    style: {
      fill: "#cfdcff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.64,10.63a1.38,1.38,0,0,0-.13.75q0,25.15,0,50.31c0,.64-.12.78-.74.75-1.14-.06-2.28,0-3.42,0-.3-.06-.35-.29-.38-.53s0-.39,0-.59V11.74c0-1.12,0-1.12,1.09-1.12Z",
    style: {
      fill: "#9fa9ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,10.62H10.65c0-1.27,0-2.53,0-3.8,0-.74.11-.84.88-.84H19.7c-.12.41-.48.3-.75.31-1,0-1.92,0-2.89,0-.73,0-.8.09-.81.83s0,1.76,0,2.64A1.19,1.19,0,0,1,15,10.62Z",
    style: {
      fill: "#f5d79b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,10.62c0-1.23,0-2.46,0-3.68,0-.64.16-.89.83-.86,1.08,0,2.15,0,3.23,0,.21,0,.44.07.61-.11H48c.71,0,.87.21.87,1V31.6a1.59,1.59,0,0,1-.25,1c-1.07-.65-2.15-1.29-3.22-2a1.12,1.12,0,0,0-1.19-.14c0-6.38,0-12.76,0-19.14,0-.65-.24-.78-.83-.78H15Z",
    style: {
      fill: "#ffdfae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.15,22.93H35.83a2.72,2.72,0,0,1,.64,0,.91.91,0,0,1,.73,1,.9.9,0,0,1-.85.9,4.51,4.51,0,0,1-.52,0H14.42a4.47,4.47,0,0,1-.52,0A1,1,0,0,1,13.83,23a4.57,4.57,0,0,1,.64,0Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.08,34.21H14.47a4.66,4.66,0,0,1-.65,0,.89.89,0,0,1-.78-.83.92.92,0,0,1,.56-1,1.81,1.81,0,0,1,.83-.1H35.84a2.25,2.25,0,0,1,.64,0,1,1,0,0,1-.14,1.88,5.81,5.81,0,0,1-.59,0Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1,29.54H14.49a5.81,5.81,0,0,1-.59,0,1,1,0,0,1-.19-1.86,2.69,2.69,0,0,1,.7-.07H35.82a2.29,2.29,0,0,1,.7.06.9.9,0,0,1,.68,1,.88.88,0,0,1-.85.83,3.72,3.72,0,0,1-.58,0Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.84,51c.08.64.17,1.28.25,1.93H14.32c-.84,0-1.28-.32-1.3-.93s.47-1,1.3-1C19.65,50.93,29.51,50.94,34.84,51Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.84,41.61v1.94H14.58c-.22,0-.43,0-.65,0a.89.89,0,0,1-.9-.91.92.92,0,0,1,.78-1,2.15,2.15,0,0,1,.51,0Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.84,46.28v1.94H14.58c-.24,0-.47,0-.71,0a.95.95,0,0,1-.19-1.84,2,2,0,0,1,.64-.08Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.08,16.15h6.46c.72,0,1.1.3,1.13.87A.88.88,0,0,1,32,18a3.94,3.94,0,0,1-.77.06H18.64c-.68-.05-1.12-.47-1.09-1s.45-.9,1.13-.9Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8,38.88H14.18c-.72,0-1.14-.35-1.16-.93s.46-1,1.17-1h7.18c.75,0,1.19.38,1.18,1s-.44.95-1.2,1Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.78,37c-1,.65-.8,1.29-1.84,1.94H25.05c-.8,0-1.2-.32-1.21-.94s.42-1,1.22-1Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.18,62.36a9.75,9.75,0,0,1-2.38-1.11,24.3,24.3,0,0,1-8.54-7.64,14.82,14.82,0,0,1-2.57-8.43c0-3,0-6.06,0-9.09A1.72,1.72,0,0,1,33,34.26l11.93-4a1.06,1.06,0,0,1,.63-.09.78.78,0,0,1,.17.6c0,4.69,0,9.37,0,14.06a1.49,1.49,0,0,1,0,.21.86.86,0,0,1,0,.28,3.45,3.45,0,0,1-.61.81c-.34.4-.52.4-.9.06l-1.72-1.47a2.17,2.17,0,0,0-3.56.91,2.09,2.09,0,0,0,.62,2.31c1.28,1.13,2.6,2.22,3.88,3.34a2.6,2.6,0,0,0,1.77.7.67.67,0,0,1,.41.11.85.85,0,0,1,.17.61c0,3,0,6.06,0,9.09C45.71,62.07,45.75,62.5,45.18,62.36Z",
    style: {
      fill: "#87c690"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.56,45.18q0-3.07,0-6.15V30.12a2.94,2.94,0,0,1,1.2.29c3.73,1.27,7.46,2.53,11.19,3.81a1.8,1.8,0,0,1,1.46,2c0,2.77,0,5.55,0,8.33a16,16,0,0,1-4.61,11.59,26.72,26.72,0,0,1-8.33,6,1.49,1.49,0,0,1-1.28.2c.26,0,.37-.12.37-.39q0-4.76,0-9.51c0-.19,0-.37-.24-.41.05-.24.28-.2.43-.29a2.42,2.42,0,0,0,1-.78c2.07-2.62,4.11-5.25,6.19-7.86a2.19,2.19,0,0,0-1.32-3.62,2.05,2.05,0,0,0-2,.81c-1.18,1.48-2.34,3-3.51,4.46C46,45,45.84,45.17,45.56,45.18Z",
    style: {
      fill: "#87c690"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.56,45.18l3.9-4.9a2.22,2.22,0,0,1,2.07-.93,2.29,2.29,0,0,1,1.57,3.74c-1.22,1.6-2.48,3.17-3.73,4.76-.84,1.08-1.69,2.15-2.54,3.23a2,2,0,0,1-1.06.78c-.35.1-.34-.18-.38-.37a5,5,0,0,1,0-.86c0-1.46,0-2.91,0-4.36a2.53,2.53,0,0,1,.16-1Z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.52,45.32c0,2,0,4,0,6,0,.19-.11.45.22.52l-.47.19a2.62,2.62,0,0,1-2-.68C42,50.24,40.68,49.13,39.38,48a2.31,2.31,0,0,1-.27-3.17,2.26,2.26,0,0,1,3.14-.44,23.41,23.41,0,0,1,2,1.71c.29.27.45.23.66-.07S45.32,45.55,45.52,45.32Z",
    style: {
      fill: "#fefefe"
    }
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTxnQuotationV1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Txn_Quotation_v1.3eb21703.svg";
export { ForwardRef as ReactComponent };